import { Search } from '@mui/icons-material';
import { Form } from '@on3/ui-lib/components/Form';
import { Input } from '@on3/ui-lib/components/Input/Input';
import { Link } from '@on3/ui-lib/components/Link';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';
import { useState } from 'react';
import { string } from 'yup';

import styles from './HeaderSearch.module.scss';

const schema = string().required();

export const HeaderSearch = ({ variant }: { variant?: 'default' | 'link' }) => {
  const { router } = useDynamicRoute();
  const [playerName, setPlayerName] = useState<string>('');

  if (variant === 'link') {
    return (
      <div data-ui="header-search">
        <Link className={styles.search} href="/rivals/search/">
          <span className="sr-only">Search</span>
          <Search />
        </Link>
      </div>
    );
  }

  const handleSearch = (searchText: string) => {
    router.push({
      pathname: `/rivals/search/`,
      query: {
        searchText,
      },
    });
  };

  return (
    <Form
      className={styles.block}
      data-ui="header-search"
      onSubmit={handleSearch}
      schema={schema}
      values={playerName}
    >
      {({ errors }) => (
        <>
          <Input
            error={errors.playerName}
            label="Search players"
            name="playerName"
            onChange={(e) => setPlayerName(e.target.value)}
            placeholder="Search players"
            srLabel
            value={playerName}
          />
          <button
            className={styles.search}
            disabled={!playerName}
            type="submit"
          >
            <span className="sr-only">Search</span>
            <Search />
          </button>
        </>
      )}
    </Form>
  );
};
